export const DOMAIN_TITLE = 'PLEO Admin';
export const DOMAIN = (process.env.NODE_ENV == "development") ? 'https://pleo.wearenotalone.fr/index.php': 'https://' + window.location.hostname + '/index.php';
//export const WWW_IMAGE_PATH = `https://pleo.wearenotalone.fr/images/`;
export const API_URL = `${DOMAIN}`;
// export const API_PORT = `5000`;
// export const API_URL = `${DOMAIN}:${API_PORT}`;



// WEBPACK FOOTER //
// ./src/config/env.js